import { createSlice } from '@reduxjs/toolkit';
import status from 'store/reducers/common/constants';
import extraReducers, {
  fetchProjects,
  fetchStatusList,
  changeStatus,
  PROJECTS_ROWS_PER_PAGE,
} from './extraReducers';

const initialState = {
  list: [],
  listCount: 0,
  listOffset: 0,
  listRequestId: null,
  status: { severity: '', message: '', type: status.IDLE_STATUS },
  statusList: [],
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {},
  extraReducers,
});

export { fetchProjects, fetchStatusList, changeStatus, PROJECTS_ROWS_PER_PAGE };
export default projectsSlice.reducer;
